import { render, staticRenderFns } from "./Selection.vue?vue&type=template&id=31536ae0&"
import script from "./Selection.vue?vue&type=script&lang=ts&"
export * from "./Selection.vue?vue&type=script&lang=ts&"
import style0 from "./Selection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports